import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        db: '#2D2D44',
        dr: '#EA2340',
        gr: '#7FB907',
        bg: '#F4F5F6',
        lr: '#ED6362',
        gold: '#EB9532'
      }
    }
  }
});
